import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import AuthContext from '../context/usuario.context';
import FirebaseContext from '../context/firebase.context';
import { constantes } from '../constantes';

export function ProviderUsuario({ children }) {
  const { logado } = useContext(FirebaseContext);
  const [usuario, setUsuario] = useState({});
  const [cadastros, setCadastros] = useState([]);
  const [userLocation, setUserLocation] = useState({});
  const [loading, setLoading] = useState(false);
  const [cadastrado, setCadastrado] = useState(false);
  const [updateUser, setUpdateUser] = useState(false);
  const [newId, setNewId] = useState(1);
  const [newIdUser, setNewIdUser] = useState();
  const [acepted, setAcepted] = useState({ terms: false, privacity: false });
  const [message, setMessage] = useState({ message: {}, selected: false });
  const [title, setTitle] = useState('Minhas Mensagens');
  const [amountNotifications, setAmountNotifications] = useState(0);

  const shared = {
    usuario,
    userLocation,
    setUserLocation,
    setUsuario,
    loading,
    setLoading,
    cadastrado,
    setCadastrado,
    newId,
    setNewId,
    newIdUser,
    setNewIdUser,
    logado,
    constantes,
    acepted,
    setAcepted,
    title,
    setTitle,
    message,
    setMessage,
    amountNotifications,
    setAmountNotifications,
    cadastros,
    setCadastros,
    updateUser,
    setUpdateUser,
  };

  return (
    <>
      <AuthContext.Provider value={{ ...shared }}>
        {children}
      </AuthContext.Provider>
    </>
  );
}
ProviderUsuario.propTypes = {
  children: PropTypes.node.isRequired,
};
